import type { Collection } from 'pkg/api/models/collection';

export function prev<T>(collection: Collection<T>): string {
	return collection.links?.previous;
}

export function next<T>(collection: Collection<T>): string {
	return collection.links?.next;
}

export function byPage<T>(collection: Collection<T>, page: number): string {
	const [link, params] = collection.links?.next
		? collection.links.next.split('?')
		: collection.links.previous.split('?');

	const linkParams: URLSearchParams = new URLSearchParams(params);

	linkParams.set('page', page.toString());

	return `${link}?${linkParams.toString()}`;
}
